import React, { useState, useEffect, useCallback } from "react";
import ThemeMaker from "../../components/thememaker";
import { useHistory } from "react-router-dom";
import { Table, Tag, Input, Checkbox } from "antd";
import axios from "axios";
import { IoIosEye } from "react-icons/io";
import { Modal as AntModal } from "antd";
import { config } from "../../utils/config";
import { Button, ConfigProvider, Flex, Tooltip } from 'antd';
import { IoIosInformationCircleOutline } from "react-icons/io";
import { AiOutlineSearch } from "react-icons/ai";
import moment from "moment";
import brandStyles from "../Brand/Brand.module.css";
import styles from "./Inventoryless.module.css";
import "../../components/mcrbTableTheme.css";

const STATUS_FILTERS = ["Action Required", "Accepted", "Rejected", "Missed"];

export default function Inventoryless() {
    const baseUrl = config.apiUrl;
    const history = useHistory();
    const [data, setData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [open, setopen] = useState(false);
    const [biddingData, setBiddingData] = useState([]);
    const [sendata, setsenddata] = useState();
    const [bidModal, setBidModal] = useState(false);
    const [bidAmount, setBidAmount] = useState([])
    const [selectedSession, setSelectedSession] = useState(null);

    const [activeFilter, setActiveFilter] = useState("Action Required");
    const [searchInput, setSearchInput] = useState("");
    const [search, setSearch] = useState("");
    const [orderCreatedOnly, setOrderCreatedOnly] = useState(false);
    const [actionLoading, setActionLoading] = useState(false);

    // Price breakup modal
    const [priceBreakupVisible, setPriceBreakupVisible] = useState(false);
    const [priceBreakupData, setPriceBreakupData] = useState(null);
    const [priceBreakupLoading, setPriceBreakupLoading] = useState(false);

    const getSessionFlags = (session) => {
        const hasPending = session?.data?.some((item) =>
            item?.bidding_quotes?.some((q) => !q?.action_taken)
        );
        const hasAccepted = session?.data?.some((item) =>
            item?.bidding_quotes?.some((q) => q?.seller_action === "ACCEPT")
        );
        const hasRejected = session?.data?.some((item) =>
            item?.bidding_quotes?.some((q) => q?.seller_action === "REJECT")
        );
        const hasOrder = session?.data?.some((item) => !!item?.order_id);

        return { hasPending, hasAccepted, hasRejected, hasOrder };
    };

    const isAllBidsFilled = () => {
        if (!selectedSession?.data?.length) return false;

        return selectedSession.data.every((item) => {
            const entry = bidAmount.find((b) => b.item_id === item?.item_id);
            return entry && entry.seller_bid !== "" && entry.seller_bid !== null && !Number.isNaN(entry.seller_bid) && entry.seller_bid > 0;
        });
    };

    const columns = [
        {
            title: "Transaction ID",
            dataIndex: "transaction_id",
        },
        {
            title: "Bid Created Date",
            render: (_, record) => <p style={{ width: "100px" }}>{moment((record?.data[0]?.created_at)).format("DD-MM-YYYY hh:mm:ss")}</p>
        },
        {
            title: "Action Required",
            render: (_, record) => {
                if (!record?.data?.length) return "-";

                const { hasPending } = getSessionFlags(record);

                return hasPending ? <Tag color={"red"}>
                    Yes
                </Tag> : <Tag color={"blue"}>
                    No
                </Tag>;


            }
        },
        {
            title: "Order Created",
            render: (_, record) => {
                if (!record?.data?.length) return "-";

                const { hasOrder } = getSessionFlags(record);

                return hasOrder ? <Tag color={"green"}>
                    Yes
                </Tag> : <Tag color={"red"}>
                    No
                </Tag>;
            }
        },
        {
            title: "Order ID",

            render: (_, record) => record?.data?.map((item, index) => {
                return <>
                    {item?.order_id ? <p
                        key={item?.order_id}
                        className="m-0 p-0"
                        style={{ width: "200px", color: "#4c2fb3", fontWeight: 600, cursor: "pointer" }}
                        onClick={() => history.push(`/orderCompleteDetail/${item.order_id}`)}
                    > {index + 1}. {item?.order_id}</p> : null}
                </>
            }) || "-"
        },
        {
            title: "No. of products",
            render: (_, record) => record?.data?.length
        },
        {
            title: "Products",
            render: (_, record) => record?.data?.map((item, index) => {
                let text = item.product_details?.attributes?.map(item => {
                    return <><p className="m-0 p-0">{item?.attribute_name}: {item?.attribute_value}</p> </>
                }) || "-"
                return <><div className="d-flex align-items-center" style={{ gap: "5px", width: "200px" }}> <p className="m-0 p-0">{`${index + 1}. `}</p>
                    <p className="m-0 p-0" > {item?.product_details?.name}</p>
                    <Tooltip placement="top" title={text}>
                        <IoIosInformationCircleOutline />
                    </Tooltip>
                </div>
                </>
            }) || "-"
        },
        {
            title: "Warehouses",
            render: (_, record) => record?.data?.map((item, index) => {
                return <>
                    <p className="m-0 p-0" style={{ width: "200px" }}> {index + 1}. {item?.product_details?.warehouse_name},{item?.product_details?.city}</p>
                </>
            }) || "-"
        },


        {
            title: "Price Details",
            render: (_, record) => record?.data?.map((item, index) => {
                let text = <><p className="m-0 p-0" style={{ width: "200px" }}>
                    <span> base price : Rs {item?.product_details?.base_price}</span> <br />
                    <span>current price : Rs {item?.product_details?.current_price}</span>   <br />
                    <span> minimum price : Rs {item?.product_details?.minimum_price}</span>  <br />
                    <span> maximum price : Rs {item?.product_details?.maximum_price}</span>  <br />
                </p> </>

                return <><div className="d-flex align-items-center" style={{ gap: "5px", width: "200px" }}> <p className="m-0 p-0">{`${index + 1}. `}</p>
                    <p className="m-0 p-0" > {item?.product_details?.name}</p>
                    <Tooltip placement="top" title={text}>
                        <IoIosInformationCircleOutline />
                    </Tooltip>
                </div>
                </>
            }) || "-"
        },
        {
            title: "Bid Status",
            dataIndex: "status",
            render: (status) => (
                <Tag color={status === "ACTIVE" ? "green" : "red"}>
                    {status}
                </Tag>
            ),
        },
        {
            title: "Price Breakup",
            render: (_, record) => {
                const { hasPending } = getSessionFlags(record);
                if (!hasPending) return "-";

                return (
                    <span
                        className={styles.priceBreakupLink}
                        onClick={() => openPriceBreakup(record)}
                    >
                        View breakup
                    </span>
                );
            }
        },

        {
            title: "Action",
            render: (_, record) => (
                <span
                    className={styles.iconBtn}
                    onClick={() => openDetails(record)}
                >
                    <IoIosEye style={{ fontSize: "18px" }} />
                </span>
            )
        }
    ];

    const openDetails = (record) => {
        setSelectedSession(record);   // store transaction_id & item_id
        let t = record.data.map(item => item?.bidding_quotes)
        let z = t.flat(1)
        const sorted = z.sort((a, b) => b.round_number - a.round_number);
        setBiddingData(sorted || []);
        setBidAmount([]);
        setopen(true);
    };

    const openPriceBreakup = async (session) => {
        setPriceBreakupVisible(true);
        setPriceBreakupLoading(true);
        setPriceBreakupData(null);

        try {
            const response = await axios({
                url: `${config.baseNodeapiUrl}/getBiddingSessions`,
                method: "POST",
            });
            const list = response?.data?.data || [];
            const match = list.find((item) => item.transaction_id === session.transaction_id);
            setPriceBreakupData(match || session);
        } catch (error) {
            console.log("Price breakup fetch error:", error);
            setPriceBreakupData(session);
        } finally {
            setPriceBreakupLoading(false);
        }
    };

    const handlesendapi = async (actionType, data) => {
        let payload;
        if (actionType !== "reject")
            payload = {
                transaction_id: selectedSession?.transaction_id,
                action: actionType,
                items: bidAmount
            };
        if (actionType === "REJECT")

            payload = {
                transaction_id: selectedSession?.transaction_id,
                action: actionType,
                items: data?.map(item => { return { "seller_bid": 0, item_id: item?.item_id } })
            };

        setActionLoading(true);

        try {
            const response = await axios({
                url: `${config.baseNodeapiUrl}/admin_dashboard_seller_bid_action`,
                method: "POST",
                data: payload
            });

            setopen(false)
            setBidModal(false);
            setBidAmount([]);
            fetchSessions(false);

        } catch (error) {
            console.log(error);
        } finally {
            setActionLoading(false);
        }

    };

    const biddingColumns = [
        {
            title: "Round Number",
            dataIndex: "round_number",
        },
        {
            title: "Item Name",
            dataIndex: "item_name",
        },

        {
            title: "Item ID",
            dataIndex: "item_id",
        },


        {
            title: "Lowest Bid",
            dataIndex: "lowest_bid",
            render: (val) => val ?? "-"
        },
        {
            title: "Seller Bid",
            dataIndex: "seller_bid",
            render: (val) => val ?? "-"
        },
        {
            title: "Action Taken",
            dataIndex: "action_taken",
            render: (val) => (val ? "Yes" : "No")
        },
        {
            title: "Seller Action",
            dataIndex: "seller_action",
            render: (val) => val ?? "-"
        },
        {
            title: "Action At",
            dataIndex: "action_at",
            render: (val) => val ? new Date(val).toLocaleString() : "-"
        },
        {
            title: "Created At",
            dataIndex: "created_at",
            render: (val) => new Date(val).toLocaleString()
        },

    ];

    const fetchSessions = useCallback(async (silent = false) => {
        if (!silent) setTableLoading(true);
        try {
            const response = await axios({
                url: `${config.baseNodeapiUrl}/getBiddingSessions`,
                method: "POST",
            });

            setData(response?.data?.data || []);
            setsenddata(response?.data?.data);
        } catch (error) {
            console.log("Error -------->", error);
        } finally {
            if (!silent) setTableLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchSessions(false);

        const interval = setInterval(() => {
            fetchSessions(true);
        }, 10000);

        return () => clearInterval(interval);
    }, [fetchSessions]);

    // Debounce search
    useEffect(() => {
        const timer = setTimeout(() => {
            setSearch(searchInput.trim().toLowerCase());
        }, 400);
        return () => clearTimeout(timer);
    }, [searchInput]);

    // Reset "Order created" toggle when leaving the Accepted tab
    useEffect(() => {
        if (activeFilter !== "Accepted") {
            setOrderCreatedOnly(false);
        }
    }, [activeFilter]);

    const filteredData = data.filter((session) => {
        const { hasPending, hasAccepted, hasRejected, hasOrder } = getSessionFlags(session);

        if (activeFilter === "Action Required" && !hasPending) return false;
        if (activeFilter === "Accepted" && (hasPending || !hasAccepted)) return false;
        if (activeFilter === "Rejected" && !hasRejected) return false;
        if (activeFilter === "Missed") return false;

        if (activeFilter === "Accepted" && orderCreatedOnly && !hasOrder) return false;

        if (!search) return true;

        return session?.data?.some((item) => {
            const name = (item?.product_details?.name || "").toLowerCase();
            const sku = (item?.product_details?.sku || "").toLowerCase();
            const orderId = (item?.order_id || "").toLowerCase();
            return name.includes(search) || sku.includes(search) || orderId.includes(search);
        });
    });



    return (
        <ThemeMaker>
            <div className={`${styles.pageWrap} mcrb-page`}>
                <div className={`${brandStyles.cardOuter} mcrb-card`}>
                    <div className={brandStyles.headerBar}>
                        <div>
                            <div className={brandStyles.title}>Auction Management</div>
                            <p className="mb-0" style={{ color: "#6B7280", fontSize: "13px", marginTop: "4px" }}>
                                Manage auction requests and bidding sessions
                            </p>
                        </div>
                        <div className={styles.statBadge} style={{ background: "rgba(255,255,255,0.14)", color: "#ffffff", border: "1px solid rgba(255,255,255,0.3)" }}>
                            Total Auctions : {data?.length || 0}
                        </div>
                    </div>

                    <div className={styles.filterRow}>
                        {STATUS_FILTERS.map((item) => (
                            <span
                                key={item}
                                className={`${styles.chip} ${activeFilter === item ? styles.chipActive : ""}`}
                                onClick={() => setActiveFilter(item)}
                            >
                                {item}
                            </span>
                        ))}

                        <div className={styles.searchWrap}>
                            <AiOutlineSearch />
                            <Input
                                bordered={false}
                                placeholder="Search by Product, SKU or Order ID..."
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                                allowClear
                            />
                        </div>

                        {activeFilter === "Accepted" && (
                            <Checkbox
                                checked={orderCreatedOnly}
                                onChange={(e) => setOrderCreatedOnly(e.target.checked)}
                            >
                                Order created
                            </Checkbox>
                        )}
                    </div>

                    <div className={`${brandStyles.bodyArea} ${styles.tableWrap} mcrb-antd`}>
                        {activeFilter === "Missed" ? (
                            <div className={styles.comingSoonWrap}>
                                <div className={styles.comingSoonTitle}>Coming Soon</div>
                                <p className={styles.comingSoonText}>Missed bids feature will be available soon.</p>
                            </div>
                        ) : (
                            <Table
                                columns={columns}
                                dataSource={filteredData}
                                rowKey="id"
                                bordered
                                loading={tableLoading}
                                scroll={{ x: 'max-content' }}
                                pagination={{
                                    pageSize: 20,
                                    showSizeChanger: false
                                }}
                                style={{ background: "#fff" }}
                            />
                        )}
                    </div>
                </div>

                {/* Bidding Details Modal */}
                <AntModal
                    open={open}
                    onCancel={() => setopen(false)}
                    footer={null}
                    centered
                    width={1200}
                    title={
                        <div style={{ fontSize: "20px", fontWeight: "700", color: "#1F2430", fontFamily: "'Sora', 'Inter', sans-serif" }}>
                            Bidding Details
                        </div>
                    }
                >
                    <div className={`${styles.modalBody} ${styles.modalTableWrap}`}>
                        <Table
                            columns={biddingColumns}
                            dataSource={biddingData}
                            rowKey="id"
                            pagination={false}
                            scroll={{ y: 350 }}
                        />
                    </div>

                    {selectedSession && getSessionFlags(selectedSession).hasPending && (
                        <div className="d-flex justify-content-end mt-4" style={{ gap: "12px" }}>
                            <button className={styles.acceptBtn} style={{ width: "200px" }} onClick={() => setBidModal(true)}>
                                ✓ Accept Bid
                            </button>

                            <button
                                className={styles.rejectBtn}
                                style={{ width: "200px" }}
                                disabled={actionLoading}
                                onClick={() => handlesendapi("REJECT", biddingData)}
                            >
                                ✕ Reject Bid
                            </button>
                        </div>
                    )}
                </AntModal>

                {/* Price Breakup Modal */}
                <AntModal
                    open={priceBreakupVisible}
                    onCancel={() => setPriceBreakupVisible(false)}
                    footer={null}
                    centered
                    width={700}
                    title={
                        <div style={{ fontSize: "18px", fontWeight: "700", fontFamily: "'Sora', 'Inter', sans-serif" }}>
                            Price Breakup
                        </div>
                    }
                >
                    <div className="mt-3">
                        {priceBreakupLoading ? (
                            <p>Loading...</p>
                        ) : !priceBreakupData ? (
                            <p>No breakup data available.</p>
                        ) : (
                            (priceBreakupData.data || []).map((item, index) => {
                                const product = item.product_details || {};
                                const quotes = Array.isArray(item.bidding_quotes) ? item.bidding_quotes : [];
                                const latestQuote = quotes[quotes.length - 1];
                                const prevQuote = quotes.length > 1 ? quotes[quotes.length - 2] : null;
                                const productPrice = product.base_price ?? product.price ?? product.minimum_price ?? "N/A";
                                const sellingPrice = product.selling_price ?? product.base_price ?? product.minimum_price ?? "N/A";
                                const packingCharge = item.packing_charge ?? item.packing_fee ?? item.delivery_fee ?? "N/A";
                                const deliveryCharge = item.delivery_charge ?? item.delivery_fee ?? item.delivery_cost ?? "N/A";
                                const bidPrice = latestQuote?.seller_bid ?? item.seller_bid ?? item.bid_price ?? "N/A";
                                const prevBid = prevQuote?.seller_bid ?? item.previous_bid ?? item.prev_bid ?? "N/A";

                                return (
                                    <div key={item.item_id || index} className={styles.breakupCard}>
                                        <div className={styles.bidLabel}>{product.name || "Product"}</div>
                                        <div className={styles.breakupRow}>
                                            <span className={styles.breakupLabel}>Previous bid</span>
                                            <span className={styles.breakupValue}>{prevBid !== null ? `Rs ${prevBid}` : "N/A"}</span>
                                        </div>
                                        <div className={styles.breakupRow}>
                                            <span className={styles.breakupLabel}>Product price</span>
                                            <span className={styles.breakupValue}>{productPrice !== "N/A" ? `Rs ${productPrice}` : "N/A"}</span>
                                        </div>
                                        <div className={styles.breakupRow}>
                                            <span className={styles.breakupLabel}>Selling price</span>
                                            <span className={styles.breakupValue}>{sellingPrice !== "N/A" ? `Rs ${sellingPrice}` : "N/A"}</span>
                                        </div>
                                        <div className={styles.breakupRow}>
                                            <span className={styles.breakupLabel}>Packing charge</span>
                                            <span className={styles.breakupValue}>{packingCharge !== "N/A" ? `Rs ${packingCharge}` : "N/A"}</span>
                                        </div>
                                        <div className={styles.breakupRow}>
                                            <span className={styles.breakupLabel}>Delivery charge</span>
                                            <span className={styles.breakupValue}>{deliveryCharge !== "N/A" ? `Rs ${deliveryCharge}` : "N/A"}</span>
                                        </div>
                                        <div className={styles.breakupRow}>
                                            <span className={styles.breakupLabel}>Bid price</span>
                                            <span className={styles.breakupValue}>{bidPrice !== "N/A" ? `Rs ${bidPrice}` : "N/A"}</span>
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>
                </AntModal>

                {/* Bid Amount Modal */}
                <AntModal
                    title={<div style={{ fontSize: "18px", fontWeight: "700", fontFamily: "'Sora', 'Inter', sans-serif" }}>Enter Bid Amount</div>}
                    open={bidModal}
                    onCancel={() => setBidModal(false)}
                    centered
                    footer={null}
                    width={600}
                >
                    <div className="mt-3">
                        {selectedSession?.data?.map((item) => (
                            <div key={item?.item_id} className={styles.bidField}>
                                <div className={styles.bidLabel}>
                                    {item?.product_details?.name}
                                </div>

                                <input
                                    type="number"
                                    className={styles.bidInput}
                                    placeholder="Enter Bid Amount"
                                    onChange={(e) => {
                                        const value = Number(e.target.value);
                                        const item_id = item?.item_id;

                                        setBidAmount((prev) => {
                                            const existing = prev.find(
                                                (i) =>
                                                    i.item_id === item_id
                                            );

                                            if (existing) {
                                                return prev.map((i) =>
                                                    i.item_id === item_id
                                                        ? {
                                                            ...i,
                                                            seller_bid:
                                                                value
                                                        }
                                                        : i
                                                );
                                            }

                                            return [
                                                ...prev,
                                                {
                                                    item_id,
                                                    seller_bid: value
                                                }
                                            ];
                                        });
                                    }}
                                />
                            </div>
                        ))}

                        <div className="text-center mt-4">
                            <button
                                className={styles.submitBtn}
                                disabled={!isAllBidsFilled() || actionLoading}
                                style={{ opacity: !isAllBidsFilled() || actionLoading ? 0.5 : 1, cursor: !isAllBidsFilled() || actionLoading ? "not-allowed" : "pointer" }}
                                onClick={() => handlesendapi("ACCEPT")}
                            >
                                Submit Bid
                            </button>
                        </div>
                    </div>
                </AntModal>
            </div>
        </ThemeMaker>
    );
}
